export async function createMap(): Promise<google.maps.Map> {
    const { Map } = (await google.maps.importLibrary("maps")) as google.maps.MapsLibrary;

    const mapStyles: google.maps.MapTypeStyle[] = [
        { featureType: "administrative", elementType: "geometry", stylers: [{ visibility: "off" }] },
        { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }, { weight: 7.5 }] },
        { featureType: "administrative.locality", stylers: [{ lightness: 5 }, { visibility: "on" }] },
        { featureType: "administrative.locality", elementType: "labels.text", stylers: [{ visibility: "on" }] },
        { featureType: "administrative.neighborhood", stylers: [{ visibility: "off" }] },
        { featureType: "landscape.natural.landcover", stylers: [{ color: "#fbf8f4" }] },
        { featureType: "poi", stylers: [{ visibility: "off" }] },
        { featureType: "poi.attraction", stylers: [{ visibility: "off" }] },
        { featureType: "road", elementType: "labels", stylers: [{ visibility: "off" }] },
        { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
        { featureType: "road.arterial", stylers: [{ visibility: "off" }] },
        { featureType: "road.highway", stylers: [{ color: "#f6dca1" }, { visibility: "simplified" }] },
        { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
        { featureType: "road.local", stylers: [{ visibility: "off" }] },
        { featureType: "transit", stylers: [{ visibility: "off" }] },
        { featureType: "water", stylers: [{ color: "#d9e8eb" }, { lightness: 10 }, { visibility: "on" }, { weight: 8 }] },
        { featureType: "water", elementType: "labels.text", stylers: [{ visibility: "off" }] },
    ];

    const center: google.maps.LatLngLiteral = { lat: 46.71109, lng: 1.7191036 };

    const mapOptions: google.maps.MapOptions = {
        center,
        zoom: 6,
        styles: mapStyles,
        mapTypeControl: false,
    };

    return new Map(document.getElementById("sl-map") as HTMLElement, mapOptions);
}
